
import React from 'react';
import { Anchor, Box } from 'grommet';

const BackLink = ({title, link, ...props}) => {
    return (
        <Box pad={{top: '18px'}} direction="row" {...props}>
            <Anchor href={`#${link}`} label={title} />
        </Box>
    );
};

export default BackLink;
